import { ComponentType } from 'src/types/component'
import * as actions from './actions'
import {
  fetchOrdersSwimlanes,
  fetchOrderSwimlaneByDate
} from 'src/api/sduiService'

const DayType = {
  orderCompleted: 'orderCompleted',
  orderBeingPrepared: 'orderBeingPrepared',
  partialCart: 'partialCart',
  menuAvailable: 'menuAvailable',
  lastOrder: 'lastOrder'
}

export const getOrdersSwimlanes = utm => dispatch => {
  dispatch(actions.fetchSwimlanes())
  fetchOrdersSwimlanes(utm)
    .then(res => res.json())
    .then(data => {
      const swimlanes = data.children
        .filter(
          child =>
            child.props.dayType === DayType.menuAvailable ||
            child.props.dayType === DayType.orderCompleted ||
            child.props.dayType === DayType.orderBeingPrepared ||
            child.props.dayType === DayType.partialCart
        )
        .reduce((prev, curr) => {
          const sw =
            curr.children.find(child => child.type === 'SWIMLANES')?.children ||
            curr.children ||
            []
          return {
            ...prev,
            [curr.props.date]: sw
          }
        }, {})

      const ratingTab = data.children.find(
        tab => tab.props.dayType === DayType.lastOrder
      )

      dispatch(
        actions.fetchSwimlanesSucceed({
          views: swimlanes,
          ratingTab
        })
      )
    })
    .catch(err => {
      console.error(err)
      dispatch(actions.fetchSwimlanesFailed())
    })
}

export const getOrderSwimlaneByDate = date => (dispatch, getState) => {
  const state = getState()

  const views = state.ordersSwimlanes?.views

  // If there are no views, fetch view tabs
  if (!views || Object.keys(views).length === 0) {
    dispatch(getOrdersSwimlanes())
    return
  }

  const isLazyLoader = views[date]?.[0]?.type === ComponentType.LAZY_LOADER

  if (isLazyLoader) {
    const path = views[date][0].props.path
    dispatch(actions.fetchSwimlane({ date, path }))
    fetchDataAfterDelay(date, 0, dispatch)
  }
}

const fetchDataAfterDelay = (date, delay, dispatch) => {
  setTimeout(() => {
    fetchOrderSwimlaneByDate(date)
      .then(res => res.json())
      .then(data => {
        const content = Array.isArray(data.children) ? data.children : []
        dispatch(
          actions.fetchSwimlaneSucceed({
            date,
            content
          })
        )
      })
      .catch(err => {
        console.error(err)
        dispatch(actions.fetchSwimlaneFailed({ date }))
      })
  }, delay)
}
